export const resources = {
  CloseIconLabel: ''
};
